import React, { useState, useRef } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
import ThuChiHopDongPrint from "components/GenericComponent/ContentPrint/ThuChiHopDongPrint";
import moment from "moment";
export const BtnXuatExcel = () => {
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong
  );

  const componentRef = useRef();
  const [dataPrint, setDataPrint] = useState({});
  const xuatExcel = () => () => {
    let { tuNgay, denNgay, ten, nhanvien, kieuvay, loaithuchi, kenhthanhtoan, tinhtrangno } =
      dataSearch;
  
    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }
    link = link +
      `thu-chi-hop-dong/xuat-excel-danh-sach-thu-chi-hop-dong-data?tungay=${tuNgay}&denngay=${denNgay}&ten=${ten}&nhanvien=${nhanvien}&kieuvay=${kieuvay}&loaithuchi=${loaithuchi}&kenhthanhtoan=${kenhthanhtoan}&tinhtrangno=${tinhtrangno}`;
    API_AUTH.get(link).then((res) => {
      setDataPrint(res.data);
      setTimeout(downExcel(), 2000);
    });
  };


  const downExcel = () => {
    var uri =
      "data:application/vnd.ms-excel," +
      encodeURIComponent(document.getElementById("htmlExcel").outerHTML);
    var downloadLink = document.createElement("a");
    downloadLink.href = uri;
    downloadLink.download =
      "ThuChiHopDong_" + moment().format("YYYYMMDDHHmm") + ".xls";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  return (
    <>
      <a
        href={() => false}
        className="icon-bgnew color-print1"
        onClick={xuatExcel()}
      >
        <PopoversBootrap
          contentText="Xuất Excel"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-tai-xuong-v2.png" />
        </PopoversBootrap>
      </a>
      <div style={{ display: "none", color:"#000000" }}> 
      <ThuChiHopDongPrint ref={componentRef} dataPrint={dataPrint} />
      </div>
    </>
  );
};
